
let UserQualification = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;
    /**
     * ��ȡ����ѧ��
     * @param {any} success
     * @param {any} error
     */
    this.Qualifications = function (success, error) {
        var url = ServiceBaseAddress + '/api/UserQualification';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
}

export { UserQualification }
